import axios from 'axios';
import { environment } from '@gaodun.com/gtools';

const prefix = environment.getApiEnv();

const http = axios.create({
    baseURL: `https://${prefix}apigateway.gaodun.com`,
    headers: {
        'Content-Type': 'application/json',
    },
});

http.interceptors.request.use(
    config => {
        const token = config.params.token || null;
        config.headers.Authentication = `Basic ${token}`;
        delete config.params.token;
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

// 预处理返回值
http.interceptors.response.use(
    (response: { data: any }) => {
        return Promise.resolve(response.data);
    },
    function (error: any) {
        return Promise.reject(error);
    },
);

// 获取权限路由
export const getNaviFuncList = <T>(userId: number, params: T): Promise<any> =>
// https://t-apigateway.gaodun.com/vigo/web/v2/users/1/navigation-functions
    http.get(`/vigo/web/v2/users/${userId}/navigation-functions`, { params });
